<style src="./BlockNavigation.scss" lang="scss"></style>

<script>
	import Link from '@/components/Link/Link';
	import Image from '@/components/Image/Image';
	import { Helper } from '@/services/helper/helper';

	/**
	 * Navigation of section blocks.
	 * @vue-prop {string} name The value for data-name attribute
	 * @vue-prop {string} background The value for data-background attribute
	 * @vue-prop {string} trackingName The value for data-tracking-name attribute
	 * @vue-prop {Object[]} navigation A list of objects containing the sublinks of navigation
	 * @vue-prop {Object[]} navigationImage An image which can be set right of the block navigation
	 * @listens Document#colCountChanged
	 */
	export default {
		name: 'HpBlockNavigation',
		props: {
			name: {
				type: String
			},
			background: {
				type: String
			},
			trackingName: {
				type: String
			},
			navigation: {
				type: Array,
				default: () => {
					return [];
				}
			},
			navigationImage: {
				type: Object
			}
		},
		components: {
			'hp-link': Link,
			'hp-image': Image
		},
		methods: {
			toggleNavigationVisibility () {
				const _this = this;

				document.addEventListener('colCountChanged', () => {
					const firstNavPoint = _this.$el.querySelector('nav ul > :first-child');

					if (!firstNavPoint) {
						return;
					}

					firstNavPoint.parentElement.style.display = '';

					_this.$nextTick().then(() => {
						if (Helper.isOverflowingParent(firstNavPoint)) {
							firstNavPoint.parentElement.style.display = 'none';
						}
					});
				});
			}
		},
		data () {
			return {};
		},
		mounted () {
			this.toggleNavigationVisibility();
		}
	};
</script>

<template>
	<div data-component="block-navigation" data-grid-row :data-name="name" :data-background="background" :data-tracking-name="trackingName">
		<h2 v-if="navigation.length">
			<hp-link v-if="navigation[0].url" v-bind="navigation[0]"></hp-link>
			<template v-else>{{ navigation[0].title }}</template>
		</h2>
		<nav v-if="navigation.length > 1">
			<ul>
				<li v-for="(element, index) in navigation.slice(1)" :key="index">
					<hp-link v-if="element.url" v-bind="element"></hp-link>
					<template v-else>{{ element.title }}</template>
				</li>
			</ul>
		</nav>
		<hp-image v-if="navigationImage" v-bind="navigationImage"></hp-image>
	</div>
</template>
